<template>
  <div class="font-16 pb-0">
    <div class="d-flex flex-column px-8 pt-8 pb-10">
      <BaseAlert
        color="var(--blue-100)"
        class="mb-9 pa-4 border-sm border-solid border-info"
      >
        <div class="d-flex">
          <div class="mr-3">
            <v-icon color="var(--blue-500)">mdi-information</v-icon>
          </div>
          <div class="primary--text">
            <span class="font-weight-bold">Important!</span>&nbsp;{{
              missingBankDetailsMessage
            }}
          </div>
        </div>
      </BaseAlert>

      <img
        src="@/assets/images/Dialog/MissingBankDetails/direct-debit-logo.png"
        alt="direct-debit-logo"
        class="mx-auto"
      />
      <p class="my-8">
        You can download a paper Direct Debit mandate using the button below:
      </p>
      <BaseButton
        text="DOWNLOAD"
        rounded
        depressed
        ripple
        color="#7c869a"
        height="52"
        class="mx-auto white--text font-weight-bold px-10 font-20"
        @click="handleDownloadDDMandate"
      />
    </div>
    <v-divider></v-divider>
    <div class="d-flex flex-column px-8 pt-10">
      <BaseButton
        text="PROCEED"
        rounded
        depressed
        ripple
        color="mustard"
        height="52"
        class="mx-auto font-weight-bold px-10 font-20 mb-4"
        @click="handleProceed"
      />
      <BaseButton
        text="Cancel"
        flat
        depressed
        ripple
        small
        link
        class="mx-auto px-1 font-weight-medium"
        @click="$emit('cancelMissingBankDetails')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogContentMissingBankDetails",
  props: {
    sortCodeLength: {
      type: Number,
      required: true,
    },
    accountNumberLength: {
      type: Number,
      required: true,
    },
  },
  components: {
    BaseButton: () => import("@/components/BaseComponents/BaseButton.vue"),
    BaseAlert: () => import("@/components/BaseComponents/BaseAlert"),
  },
  computed: {
    missingBankDetailsMessage() {
      if (this.accountNumberLength === 0 && this.sortCodeLength !== 0) {
        return "Are you sure you want to proceed without entering an Account number?";
      }
      if (this.sortCodeLength === 0 && this.accountNumberLength !== 0) {
        return "Are you sure you want to proceed without entering a Sort code?";
      }
      if (this.accountNumberLength === 0 && this.sortCodeLength === 0) {
        return "Are you sure you want to proceed without entering any bank details?";
      }
      return "";
    },
  },
  methods: {
    handleDownloadDDMandate() {
      window.open(
        "https://www.paymentshield-advisers.co.uk/resources/pdf/ddform.pdf",
        "_blank"
      );
    },
    handleProceed() {
      this.$emit("missingBankDetails");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn:not([type="text"]) {
  width: 100%;
  max-width: 420px;
}

img {
  display: block;
  max-width: 180px;
}
</style>
